module.exports = __webpack_public_path__ + "static/media/nude_program_preview_20180508-3.e62c018c.jpg";